import { render, staticRenderFns } from "./AreaCompanyOrder.vue?vue&type=template&id=08869d1b&scoped=true&"
import script from "./AreaCompanyOrder.vue?vue&type=script&lang=js&"
export * from "./AreaCompanyOrder.vue?vue&type=script&lang=js&"
import style0 from "./AreaCompanyOrder.vue?vue&type=style&index=0&id=08869d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08869d1b",
  null
  
)

export default component.exports